export const FETCH_DISCOUNT_AND_OTHER_DATA = "FETCH_DISCOUNT_AND_OTHER_DATA";
